import { render, staticRenderFns } from "./C-3-1a__ProductInfoEdit_BackStage.vue?vue&type=template&id=2b246d06&"
import script from "./C-3-1a__ProductInfoEdit_BackStage.vue?vue&type=script&lang=js&"
export * from "./C-3-1a__ProductInfoEdit_BackStage.vue?vue&type=script&lang=js&"
import style0 from "./C-3-1a__ProductInfoEdit_BackStage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
